const { get } = require('lodash');

const getPackageImages = (listing, packageId, listingImages) => {
  const images = listingImages || get(listing, 'images', []);
  const publicData = get(listing, 'attributes.publicData', {});
  const packages = get(publicData, 'packages', []);
  const packageData = packages.find(item => item.id === packageId);

  if (packageData) {
    const { images: packageImages } = packageData || {};

    return (packageImages || [])
      .map(imageId => {
        const packageImage = images.find(image => image.id.uuid === imageId);

        return packageImage;
      })
      .filter(Boolean);
  }

  return undefined;
};

const getLodgingPricesOptions = listing => {
  const lodging = get(listing, 'attributes.publicData.lodging', null);
  const hasLodging = get(lodging, 'hasLodging', false);

  const lodgingPricesOptions = [];

  if (hasLodging) {
    const lodgingType = get(lodging, 'type', '');
    const lodgingPrice = get(lodging, 'price', null);
    const lodgingInfo = get(lodging, 'overallInfo', null);

    if (lodgingPrice) {
      lodgingPricesOptions.push({
        price: lodgingPrice,
        type: lodgingType,
        info: lodgingInfo,
        index: 0,
      });
    }
  }

  const campsites = get(listing, 'attributes.publicData.campsites', []);

  campsites.forEach((campsite, index) => {
    if (campsite.allowsTents) {
      const tentPrice = get(campsite, 'tent.price', null);
      const tentInfo = get(campsite, 'tent.info', null);

      lodgingPricesOptions.push({
        price: tentPrice,
        type: 'tent',
        info: tentInfo,
        index,
      });
    }

    if (campsite.allowsRvs) {
      const rvPrice = get(campsite, 'rv.price', null);
      const rvCampsiteName = get(campsite, 'rv.campsiteName', '');
      const rvInfo = get(campsite, 'rv.info', null);

      lodgingPricesOptions.push({
        price: rvPrice,
        type: 'rv',
        name: rvCampsiteName,
        info: rvInfo,
        index,
      });
    }
  });

  return lodgingPricesOptions;
};

module.exports = { getPackageImages, getLodgingPricesOptions };
